import classNames from "classnames";
import * as React from "react";
import Render from "../../Render";
import { dynamicOpacityFormClass, sharedFormStyleClass } from "../Form";
import * as formStyles from "../Form.css";
import * as styles from "./FormSelect.css";
import { IFormSelectOptions } from "./IFormSelectOptions";

export function FormSelect({
    id,
    label,
    width,
    minWidth,
    maxWidth,
    suggestions,
    classes,
    style,
    onChange,
    onFocus,
    onDefocus,
    onEnter,
    value,
    readonly = false,
    dynamicOpacity = false,
    hideEmptyOption = false,
}: IFormSelectOptions) {
    if (!suggestions) {
        suggestions = [];
    }

    return (
        <span className={formStyles.main}>
            <span className={formStyles.label}>{label}</span>
            <select
                id={id}
                style={{ width, minWidth, maxWidth, ...style }}
                className={classNames(
                    [formStyles.formControl, styles.formSelect],
                    classes,
                    sharedFormStyleClass,
                    {
                        [dynamicOpacityFormClass]: dynamicOpacity,
                    }
                )}
                onChange={onChange}
                onFocus={onFocus}
                value={value}
                disabled={readonly}
                onKeyDown={async (event) => {
                    if (event.key === "Enter" && onEnter) {
                        if (!event.shiftKey) {
                            onEnter(value);
                            event.preventDefault();
                        }
                    }
                }}
            >
                {hideEmptyOption ? null : <option />}
                {suggestions.map((elem, index) => (
                    <option value={elem} key={index} defaultValue="true">
                        {elem}
                    </option>
                ))}
            </select>
            <Render
                id="pressEnterLabel"
                when={onEnter && value}
                withClasses={formStyles.pressEnterLabelFormSelect}
            >
                ↵
            </Render>
        </span>
    );
}
